import React, { type MouseEventHandler } from 'react'
import type { LinkProps } from 'react-router-dom'
import { ArrowShortLeftIcon } from '@fourthwall/icons'
import { ButtonClean } from '../ButtonClean'

export type BackButtonProps = {
  label: string
  to?: LinkProps['to']
  state?: LinkProps['state']
  onClick?: MouseEventHandler<HTMLButtonElement>
}

export const BackButton = ({ label, to, state, onClick }: BackButtonProps) => {
  return (
    <ButtonClean
      label={label}
      icon={ArrowShortLeftIcon}
      to={to}
      state={state}
      onClick={onClick}
      appearance="secondary"
      withUnderline={false}
    />
  )
}
